import React from "react";
import { Sports, Description, Speed, Language } from "@mui/icons-material";
import "boxicons/css/boxicons.min.css";

const FeaturedServicesSection = () => {
  return (
    <section id="featured-services" className="featured-services">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div
            className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="icon-box">
              <div className="icon">
                <i className="bx bxl-dribbble"></i>
              </div>

              <h4 className="title">Cualquier deporte</h4>
              <p className="description">
                Puedes organizar torneos de basquet, voley, fúbol, tenis o el
                deporte que quieras
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="icon-box">
              <div className="icon">
                <i className="bx bx-file"></i>
              </div>

              <h4 className="title">No más Excel ni papeles</h4>
              <p className="description">
                Tienes toda la información de tu torneo en un solo lugar y
                puedes consultarla cuando quieras
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="icon-box">
              <div className="icon">
                <i className="bx bx-tachometer"></i>
              </div>

              <h4 className="title">Rápido</h4>
              <p className="description">
                En menos de cinco minutos, tendrás la próxima fecha organizada
              </p>
            </div>
          </div>

          <div
            className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="icon-box">
              <div className="icon">
                <i className="bx bx-world"></i>
              </div>

              <h4 className="title">No más reclamos</h4>
              <p className="description">
                Todos los equipos jugarán en un día, horario y lugar en el que
                tengan disponibilidad
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedServicesSection;
